// extracted by mini-css-extract-plugin
module.exports = {"largeNavigation":"_8EFahPg"};